import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl } from "../endpoints";
// import { Pokemon } from './types';

// Define a service using a base URL and expected endpoints
export const authService = createApi({
  reducerPath: "authService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["auth"],
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (body) => {
        return {
          url: "/login",
          method: "POST",
          body: body,
        };
      },
    }),
    logoutUser: builder.query({
      query: () => "/logout",
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginUserMutation, useLogoutUserQuery } = authService;
